import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useOutletsQuery } from '../../Store/Apis/outletApi';
import { isDropdownPermission } from '../../Hooks/permissionsMiddleware';

const AddEditServiceSpec = ({ onSubmit, data }) => {
  const [category, setCategory] = useState(data?.category || '');
  const [serviceName, setServiceName] = useState(data?.serviceName || '');
  const servicesList = useOutletsQuery()
  const user = useSelector((state) => state.auth.user);
  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({ category: category, serviceName });
  };

  useEffect(() => {
    if (user.role !== 'superAdmin') {
      setCategory(user.outletID);
    }
  }, []);

  return (
    <form onSubmit={handleSubmit} className="">
      <div className="mb-3">
        <label htmlFor="category" className="form-label">Category</label>
        <select
          id="category"
          className="form-select"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          required
          disabled={(servicesList.isSuccess === true && !isDropdownPermission(user.role_Id))}
        >
          <option value="">Select a Category</option>
            {
                servicesList?.data?.data.map((elem, i)=> {
                  return (<option value={elem.outletId} key={i}>{elem.outletName}</option>)
                })
            }
        </select>
      </div>

      <div className="mb-3">
        <label htmlFor="serviceName" className="form-label">Service Type Name</label>
        <input
          type="text"
          className="form-control"
          id="serviceName"
          value={serviceName}
          onChange={(e) => setServiceName(e.target.value)}
          required
        />
      </div>

      <button type="submit" className="btn btn-primary">
        {data ? 'Update Service Specification' : 'Create Service Specification'}
      </button>
    </form>
  );
};

export default AddEditServiceSpec;